/* eslint-disable */
import * as yup from 'yup';
import * as XLSX from 'xlsx';
import { toastConfig } from 'config';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import moment from 'moment';
import MainCard from 'components/MainCard';
import { createPortal } from 'react-dom';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { first, isEmpty, isString } from 'lodash';
import { App, Empty, Flex, Spin } from 'antd';
import { NumericFormat } from 'react-number-format';
import pdfIcon from 'assets/images/icons/pdf_red.svg';
import LynIcon from 'components/@extended/LynIcon';
import IconButton from 'components/@extended/IconButton';
import SendOutlined from '@ant-design/icons/SendOutlined';
import CloseOutlined from '@ant-design/icons/CloseOutlined';
import CheckOutlined from '@ant-design/icons/CheckOutlined';
import cancelIcon from 'assets/images/icons/deactivated.svg';
import pdfIconDisable from 'assets/images/icons/pdf_gray.svg';
import viewIcon from 'assets/images/table-icons/view_blue.svg';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import editIcon from 'assets/images/table-icons/edit_green.svg';
import { currencyFormatter, generateExcelFileName, numberFormatter } from 'utils/utils';
import deleteIcon from 'assets/images/table-icons/delete_red.svg';
import staticEditModalList from 'static-solutions/staticEditModalList';
import { TanStackColumnFilter } from 'components/@extended/ColumnFilter';
import ComptrollerConfirmModal from 'pages/comptroller/ComptrollerConfirmModal';
import { SelectVisibleColumnV8 } from 'components/@extended/SelectVisibleColumn';
import { TranStackPagination } from 'components/LynDataTable/DataTablePagination';
import { TanStackColumnSorting } from 'components/@extended/SortingIconGroup';
import BulkStatusActionButton from 'components/button/BulkStatusActionButton';
import IdentityCaseChatModal from 'pages/IdentityCase/IdentityCaseChatModal';
import { toTrimmedString } from 'utils/utils';
import { useGetSingleIdentityMutation, useGetSpacialCaseDetailsMutation } from 'store/features/process/processApi';
import { flexRender, getCoreRowModel, getFilteredRowModel, getPaginationRowModel, getSortedRowModel, useReactTable } from '@tanstack/react-table';
import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, Paper, Stack, TextField, Tooltip, Typography } from '@mui/material';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import tableDesign from '../../themes/table';
import ExportButton from 'components/button/ExportButton';

const chatIcon = (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 19" fill="none">
		<g clipPath="url(#clip0_1226_2429)">
			<path
				d="M4.83702 12.5304C6.10858 13.1827 7.5713 13.3594 8.96159 13.0286C10.3519 12.6978 11.5783 11.8814 12.4199 10.7264C13.2615 9.57136 13.6629 8.15373 13.5517 6.72896C13.4406 5.30419 12.8242 3.96597 11.8137 2.95544C10.8032 1.94492 9.46493 1.32854 8.04016 1.21739C6.61539 1.10624 5.19777 1.50762 4.04275 2.34921C2.88774 3.19079 2.07129 4.41724 1.74052 5.80753C1.40976 7.19783 1.58644 8.66055 2.23872 9.9321L0.90625 13.8629L4.83702 12.5304Z"
				stroke="#4A5565"
				strokeWidth="1.33247"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_1226_2429">
				<rect width="20" height="20" fill="white" />
			</clipPath>
		</defs>
	</svg>
);

const enhanceColumnsWithFiltering = (columns) => {
	// console.log('columns', columns);
	return columns.map((column) => {
		// Create a copy to avoid modifying the original objects
		const enhancedColumn = { ...column };

		// Ensure filtering is properly enabled unless explicitly disabled
		if (enhancedColumn.enableColumnFilter !== false) {
			enhancedColumn.enableColumnFilter = true;
		}

		// For text columns, explicitly define the filter function
		if (enhancedColumn.dataType?.toLowerCase() === 'text') {
			enhancedColumn.filterFn = 'includesString';
		}

		return enhancedColumn;
	});
};

const FILTER_STORAGE_KEY = 'table-column-filters';

const getInitialColumnFilters = () => {
	try {
		const saved = localStorage.getItem(FILTER_STORAGE_KEY);
		return saved ? JSON.parse(saved) : [];
	} catch {
		return [];
	}
};

const tableVariants = {
	default: {
		table: {
			tableLayout: 'fixed',

			'& td, th': {
				borderRight: 1,

				borderColor: tableDesign.borderColor.primary,
			},

			'& th': {
				'&:first-of-type': { borderLeft: `1px solid ${tableDesign.borderColor.primary}` },
			},

			// '& th:not(:last-of-type)': { borderRight: 1, borderColor: 'common.white' },
		},
		tableMainCard: {
			mt: 2,
			width: '100%',
			overflow: 'hidden',
			borderColor: tableDesign.borderColor.primary,
			borderRadius: tableDesign.borderRadius.primary,
			border: 'none',
		},
		tableContainer: {
			width: '100%',
			display: 'block',
			overflowX: 'auto',
			position: 'relative',
			maxHeight: `calc(100svh - 358px)`,

			'& td, & th': { whiteSpace: 'nowrap' },
		},
		tableBodyCell: {
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			borderBottom: '1px solid #E0E0E0',
			padding: tableDesign.padding.primary,
			color: tableDesign.color.secondary,

			'&:first-of-type': { borderLeft: '1px solid', borderColor: tableDesign.borderColor.primary },
		},
		tableHeaderCell: {
			// p: 0.5,
			top: '40px',
			height: '40px',
			position: 'sticky',
			backgroundColor: tableDesign.background.primary,
			padding: tableDesign.padding.default,

			'& .ant-input-affix-wrapper': { border: '1px solid #ced4da !important' },
		},
		tableHeaderSelectionCell: {
			// py: 1.5,
			padding: tableDesign.padding.default,
			color: tableDesign.color.primary,
			backgroundColor: tableDesign.background.primary,

			// backgroundColor: 'red',
		},
		tableHeaderRow: {
			height: '40px',
		},
		tableHeaderSelectionBox: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
		tableBodyRow: { cursor: 'pointer' },
		emptyTableBox: {
			width: '100%',
			height: '350px',
			display: 'flex',
			alignItems: 'center',
			flexDirection: 'column',
			justifyContent: 'center',
		},
		paginationBox: {
			width: '100%',
			backgroundColor: tableDesign.background.primary,
		},
		pagination: {
			'&.Mui-disabled': { color: 'red' },
			'&.MuiTablePagination-root': { color: tableDesign.color.primary },
			'.MuiTablePagination-selectIcon': { color: tableDesign.color.primary },
		},
	},
};

export function IdentityFeaturedTable({
	setData,
	data = [],
	columns = [],
	rowSelection,
	processDetails,
	setRowSelection,
	selectedTabName,
	handleSelectRow,
	variant = 'default',
	approveRejectHandler,
	expectedURLToRedirect,
	activeDeactivateHandle,
	xlsxFileName = 'lynorg',
	setFilterData = () => {},
}) {
	const theme = useTheme();
	const location = useLocation();
	const [searchParams, setSearchParams] = useSearchParams();
	const [headerColumnSlotEl, setHeaderColumnSlotEl] = useState(null);
	const [headerExportSlotEl, setHeaderExportSlotEl] = useState(null);

	const pageIndexFromParams = searchParams.get('page');
	const pageSizeFromParams = searchParams.get('size');

	const initialPageIndex = pageIndexFromParams ? Number(pageIndexFromParams) : 0;
	const initialPageSize = pageSizeFromParams ? Number(pageSizeFromParams) : 15;

	const [originalData, setOriginalData] = useState(() => [...(data || [])]);
	const [selectedRow, setSelectedRow] = useState({});
	const [showModal, setShowModal] = useState(false);
	const [selectedIndex, setSelectedIndex] = useState();
	const [isChatModalOpen, setIsChatModalOpen] = useState(false);
	const [chatModalItem, setChatModalItem] = useState(null);

	const [columnFilters, setColumnFilters] = useState(getInitialColumnFilters);

	const [GetSingleIdentity, { data: singleCaseData, error: singleCaseError, isSuccess: isSingleCaseSuccess, isError: isSingleCaseError }] =
		useGetSingleIdentityMutation();

	const [GetSpacialCaseDetails, { data: caseDetails, isSuccess: isCaseDetailsSuccess, isLoading: isCaseDetailsLoading }] =
		useGetSpacialCaseDetailsMutation();

	const handleColumnFiltersChange = (updater) => {
		const newFilters = typeof updater === 'function' ? updater(columnFilters) : updater;
		setColumnFilters(newFilters);

		table.setPageIndex(0);

		if (newFilters?.length > 0) {
			setSearchParams(
				(prev) => {
					const newParams = new URLSearchParams(prev);
					newParams.delete('page');

					return newParams;
				},
				{ replace: true }
			);
		}
	};

	const handleOpenChatModal = useCallback(
		async (item) => {
			const resourceId = toTrimmedString(item?.id);
			const processCode = toTrimmedString(processDetails?.processCode);

			console.log('Opening chat modal for item:', item);

			if (!resourceId) {
				toast.error('Missing resource id.', toastConfig);
				return;
			}
			if (!processCode) {
				toast.error('Missing process code.', toastConfig);
				return;
			}

			try {
				setChatModalItem(item);
				setIsChatModalOpen(true);
			} catch (error) {
				toast.error('Failed to load chat.', toastConfig);
			}
		},
		[processDetails?.processCode]
	);

	const handleCloseChatModal = useCallback(() => {
		setIsChatModalOpen(false);
		setChatModalItem(null);
	}, []);

	const columnsWithChat = useMemo(() => {
		const safeColumns = Array.isArray(columns) ? columns : [];
		const hasChatColumn = safeColumns.some((column) => {
			const key = column?.id || column?.accessorKey || column?.key;
			return ['chat', 'Chat'].includes(key);
		});

		if (hasChatColumn) return safeColumns;

		return [
			...safeColumns,
			{
				id: 'chat',
				header: 'Chat',
				enableColumnFilter: false,
				cell: ({ row }) => (
					<Button
						variant="text"
						startIcon={chatIcon}
						onClick={(event) => {
							event.stopPropagation();
							handleOpenChatModal(row?.original);
						}}
						sx={{
							minWidth: 0,
							textTransform: 'none',
							fontSize: '12px',
							color: '#4A5565',
							'&:hover': { backgroundColor: 'rgba(148, 163, 184, 0.12)' },
						}}
					>
						Chat
					</Button>
				),
				meta: {
					style: { textAlign: 'center', width: '120px' },
				},
			},
		];
	}, [columns, handleOpenChatModal]);

	const table = useReactTable({
		data: data || [],
		columns: enhanceColumnsWithFiltering(columnsWithChat),
		state: {
			pagination: {
				pageIndex: initialPageIndex,
				pageSize: initialPageSize,
			},
			columnFilters,
		},
		onColumnFiltersChange: handleColumnFiltersChange,
		initialState: {
			columnVisibility: visibleColumnFunc(columnsWithChat),
			columnPinning: piningColumnFunc(columnsWithChat),
		},
		defaultColumn: {
			cell: RowEditable,
		},
		meta: {
			selectedRow,
			setSelectedRow,
			saveData: (rowIndex) => {
				const row = data?.[rowIndex];

				if (row) {
					setSelectedIndex(rowIndex);
					GetSingleIdentity({
						_id: row.id,
						operation: 'update-single',
						processCode: processDetails.processCode,
						suffixCode: '',
						data: row,
						version: row?.version,
					});
				}
			},
			revertData: (rowIndex) => {
				setData((old) => old.map((row, index) => (index === rowIndex ? originalData[rowIndex] : row)));
			},
			updateSingleCellData: (rowIndex, columnId, value) => {
				setData((old) =>
					old.map((row, index) => {
						if (index === rowIndex) {
							return {
								...old[rowIndex],
								[columnId]: value,
							};
						}
						return row;
					})
				);
			},
			submitOperation: (id, operation, rowIndex) => {
				setSelectedIndex(rowIndex);
				GetSingleIdentity({
					_id: id,
					operation,
					processCode: processDetails.processCode,
					suffixCode: '',
				});
			},
		},
		filterFns: {
			textFilter: (row, columnId, filterValue) => {
				if (!filterValue) return true;
				const cellValue = String(row.getValue(columnId) || '').toLowerCase();
				const searchValue = String(filterValue).toLowerCase();
				return cellValue.includes(searchValue);
			},
		},
		globalFilterFn: 'textFilter',

		enableRowSelection: true,
		getCoreRowModel: getCoreRowModel(),
		getSortedRowModel: getSortedRowModel(),
		getFilteredRowModel: getFilteredRowModel(),
		getPaginationRowModel: getPaginationRowModel(),
	});

	const getDetailsHandler = (cell) => {
		const columnDetailsQuery = cell.column.columnDef?.columnDetailsQuery;
		const isEditEnabled = selectedRow?.[cell?.row?.id];

		if (!isEditEnabled && columnDetailsQuery) {
			const columnKeys = Object.keys(cell.row.original ?? []);
			const columnValues = Object.values(cell.row.original ?? []).map((item) => {
				if (isString(item)) return item;
				return JSON.stringify(item);
			});

			if (columnValues && columnKeys) {
				GetSpacialCaseDetails({
					reportCode: columnDetailsQuery,
					fieldCodes: columnKeys,
					fieldValues: columnValues,
				});
				setShowModal(true);
			}
		}
	};

	const dataExport = useCallback(() => {
		const headerArr = table
			?.getVisibleLeafColumns()
			?.map((item) => item.id)
			?.filter((item) => item !== 'Selection' && item !== 'activationStatus' && item !== 'Action' && item !== 'chat' && item !== 'Chat');

		const mainColumn = columnsWithChat
			?.filter((item) => item.id !== 'Selection' && item.key !== 'activationStatus' && item.key !== 'Action' && item.id !== 'chat')
			.reduce((acc, col) => {
				acc[col.key] = col.header;
				return acc;
			}, {});

		const Header = headerArr.map((item) => {
			if (mainColumn?.[item]) {
				return mainColumn?.[item];
			} else {
				return item;
			}
		});

		const rows = table.getFilteredRowModel().rows;
		const rowsArr = rows.map((row) => {
			const rowObj = {};
			headerArr.forEach((colId) => {
				rowObj[colId] = row.getValue(colId);
			});
			return rowObj;
		});

		const wb = XLSX.utils.book_new();
		const ws = XLSX.utils.json_to_sheet([]);
		XLSX.utils.sheet_add_aoa(ws, [Header]);
		XLSX.utils.sheet_add_json(ws, rowsArr, { origin: 'A2', skipHeader: true });
		XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
		XLSX.writeFile(wb, `${generateExcelFileName(xlsxFileName)}.xlsx`);
	}, []);

	useEffect(() => {
		localStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(columnFilters));
	}, [columnFilters]);

	useEffect(() => {
		setRowSelection(table?.getSelectedRowModel()?.flatRows);
	}, [table?.getSelectedRowModel()?.flatRows]);

	useEffect(() => {
		if (isSingleCaseSuccess) {
			if (!isEmpty(singleCaseData?.data)) {
				if (singleCaseData?.recordStatus === 'deleted') {
					setData((prev) => {
						return prev.filter((item) => item.id !== singleCaseData?._id);
					});
					setOriginalData((prev) => {
						return prev.filter((item) => item.id !== singleCaseData?._id);
					});
				} else {
					setData((old) =>
						old.map((row, index) => {
							if (index === selectedIndex) {
								return {
									key: index,
									recordId: singleCaseData._id,
									id: singleCaseData._id,
									...singleCaseData?.data,
									parkedData: singleCaseData?.parkedData,
									recordStatus: singleCaseData.recordStatus,
									version: singleCaseData?.version,
									parkAction: singleCaseData?.parkAction,
								};
							}
							return row;
						})
					);

					setOriginalData((old) =>
						old.map((row, index) => {
							if (index === selectedIndex) {
								return {
									key: index,
									recordId: singleCaseData._id,
									id: singleCaseData._id,
									...singleCaseData?.data,
									parkedData: singleCaseData?.parkedData,
									recordStatus: singleCaseData.recordStatus,
									version: singleCaseData?.version,
									parkAction: singleCaseData?.parkAction,
								};
							}
							return row;
						})
					);
				}
			}

			toast.success('Success! Action completed ', toastConfig);
		}

		if (isSingleCaseError) {
			if (singleCaseError?.data?.code === '501') {
				toast.error(singleCaseError?.data?.message, toastConfig);
			} else {
				toast.error('Failed! Action not completed', toastConfig);
			}
			setData((old) => old.map((row, index) => (index === selectedIndex ? originalData[selectedIndex] : row)));
		}
	}, [isSingleCaseSuccess, isSingleCaseError]);

	useEffect(() => {
		return () => {
			setTimeout(() => {
				let expectedURLArr = ['/case-identity/details', '/case-identity/edit'];

				if (expectedURLToRedirect) {
					expectedURLArr.push(`${expectedURLToRedirect}/edit`, `${expectedURLToRedirect}/details`);
				}

				if (window.location.pathname !== location.pathname && !expectedURLArr.includes(window.location.pathname)) {
					return window.localStorage.removeItem(FILTER_STORAGE_KEY);
				}
			}, 0);
		};
	}, []);

	useEffect(() => {
		if (table?.getFilteredRowModel()?.flatRows?.length > 0) {
			const filterData = table.getFilteredRowModel().flatRows?.map((row) => row.original);

			setFilterData(filterData);
		}
	}, [table?.getFilteredRowModel()?.flatRows]);

	useEffect(() => {
		setHeaderColumnSlotEl(document.getElementById('identity-table-columns-slot'));
		setHeaderExportSlotEl(document.getElementById('identity-table-export-slot'));

		return () => {
			setHeaderColumnSlotEl(null);
			setHeaderExportSlotEl(null);
		};
	}, []);

	const styles = {
		table: { ...tableVariants.default.table, ...tableVariants[variant]?.table },
		pagination: { ...tableVariants.default.pagination, ...tableVariants[variant]?.pagination },
		tableBodyRow: { ...tableVariants.default.tableBodyRow, ...tableVariants[variant]?.tableBodyRow },
		emptyTableBox: { ...tableVariants.default.emptyTableBox, ...tableVariants[variant]?.emptyTableBox },
		tableMainCard: { ...tableVariants.default.tableMainCard, ...tableVariants[variant]?.tableMainCard },
		paginationBox: { ...tableVariants.default.paginationBox, ...tableVariants[variant]?.paginationBox },
		tableBodyCell: { ...tableVariants.default.tableBodyCell, ...tableVariants[variant]?.tableBodyCell },
		tableContainer: { ...tableVariants.default.tableContainer, ...tableVariants[variant]?.tableContainer },
		tableHeaderRow: { ...tableVariants.default.tableHeaderRow, ...tableVariants[variant]?.tableHeaderRow },
		tableHeaderCell: { ...tableVariants.default.tableHeaderCell, ...tableVariants[variant]?.tableHeaderCell },
		tableHeaderSelectionBox: {
			...tableVariants.default.tableHeaderSelectionBox,
			...tableVariants[variant]?.tableHeaderSelectionBox,
		},
		tableHeaderSelectionCell: {
			...tableVariants.default.tableHeaderSelectionCell,
			...tableVariants[variant]?.tableHeaderSelectionCell,
		},
	};

	const columnPicker = <SelectVisibleColumnV8 table={table} allColumns={table?.getAllColumns()} visibleColumns={[]} />;
	const exportButton = <ExportButton handleDataExport={dataExport} />;

	return (
		<>
			{headerColumnSlotEl ? createPortal(columnPicker, headerColumnSlotEl) : null}
			{headerExportSlotEl ? createPortal(exportButton, headerExportSlotEl) : null}

			<Box content="div" sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 1 }}>
				{headerColumnSlotEl ? null : columnPicker}
				<Flex align="center" gap=".5rem">
					{Object.keys(rowSelection)?.length > 0 && (
						<>
							<div>
								<b style={{ fontSize: '14px' }}>{Object.keys(rowSelection)?.length}</b>{' '}
								{Object.keys(rowSelection)?.length > 1 ? 'rows' : 'row'} selected
							</div>
							{![
								'Active',
								'Worklist',
								'Draft',
								'All',
								// 'Pending Submission',
								// 'Under Processing',
								// 'Pending Payment',
								// 'Pending Disbursement',
								// 'Disbursed',
								// 'Returned',
								// 'Pending Boxing',
								// 'Boxed',
							]?.includes(selectedTabName) && (
								<BulkStatusActionButton
									action="activate"
									label={Object.keys(rowSelection)?.length > 1 ? 'Activate all' : 'Activate'}
									tooltip={Object.keys(rowSelection)?.length > 1 ? 'Activate all' : 'Activate'}
									onClick={(e) => {
										e.stopPropagation();
										activeDeactivateHandle('Inactive');
									}}
								/>
							)}
							{![
								'Inactive',
								'Worklist',
								'Draft',
								'All',
								// 'Pending Submission',
								// 'Under Processing',
								// 'Pending Payment',
								// 'Pending Disbursement',
								// 'Disbursed',
								// 'Returned',
								// 'Pending Boxing',
								// 'Boxed',
							]?.includes(selectedTabName) && (
								<BulkStatusActionButton
									action="deactivate"
									label={Object.keys(rowSelection)?.length > 1 ? 'Deactivate all' : 'Deactivate'}
									tooltip={Object.keys(rowSelection)?.length > 1 ? 'Deactivate all' : 'Deactivate'}
									onClick={(e) => {
										e.stopPropagation();
										activeDeactivateHandle('Active');
									}}
								/>
							)}
							{['Draft']?.includes(selectedTabName) && (
								<Tooltip title={Object.keys(rowSelection)?.length > 1 ? 'Submit all' : 'Submit'}>
									<Button
										className="animated-button"
										type="primary"
										// style={{ backgroundColor: theme.palette.lynTheme.submit, color: "white" }}
										sx={{
											backgroundColor: '#03396c',
											color: '#fff',
											padding: '8px 8px',
											fontSize: '14px',
											lineHeight: '18px',
											'&:hover': { backgroundColor: '#03396c' },
										}}
										onClick={(e) => {
											e.stopPropagation();
											activeDeactivateHandle('Save');
										}}
									>
										Submit
									</Button>
								</Tooltip>
							)}
							{/* <Tooltip title={Object.keys(rowSelection)?.length > 1 ? "Delete all" : "Delete"}>
									<Button
										type="primary"
										style={{ backgroundColor: theme.palette.lynTheme.delete, color: "white" }}
										onClick={(e) => {
											e.stopPropagation();
											if (typeof deleteHandle === "function") {
											let arr = rowSelection?.map((item) => item?.original);
											deleteHandle(arr);
											}
										}}
									>
										{Object.keys(rowSelection)?.length > 1 ? "Delete all" : "Delete"}
									</Button>
								</Tooltip> */}
							{!['Active', 'NEW_INACTIVE', 'Inactive', 'Draft', 'All']?.includes(selectedTabName) && (
								<>
									<BulkStatusActionButton
										action="approve"
										label="Approve"
										tooltip="Approve"
										onClick={(e) => {
											e.stopPropagation();
											if (typeof approveRejectHandler === 'function') {
												const data = table.getSelectedRowModel().flatRows.map((item) => item.original);
												approveRejectHandler(data, 'Approve');
											}
										}}
									/>

									<BulkStatusActionButton
										action="reject"
										label="Reject"
										tooltip="Reject"
										onClick={(e) => {
											e.stopPropagation();
											if (typeof approveRejectHandler === 'function') {
												const data = table.getSelectedRowModel().flatRows.map((item) => item.original);
												approveRejectHandler(data, 'Reject');
											}
										}}
									/>
								</>
							)}
						</>
					)}

					{/* <Button
						disableRipple
						color="secondary"
						aria-haspopup="true"
						onClick={dataExport}
						aria-label="open profile"
						sx={{
							padding: '5px 12px',
							color: 'text.primary',
							bgcolor: 'common.white',
							border: `1px solid ${theme.palette.border}`,
						}}
					>
						<Stack direction="row" gap={1}>
							<LynIcon folder="icons" fileName={'export'} format="svg" sx={{ marginRight: '4px' }} />{' '}
							<Typography style={{ mt: '12px' }}>Export</Typography>
						</Stack>
					</Button> */}

					{headerExportSlotEl ? null : exportButton}
				</Flex>
			</Box>

			<MainCard content={false} sx={styles.tableMainCard}>
				<TableContainer sx={styles.tableContainer}>
					<Table stickyHeader size="medium" sx={styles.table}>
						<TableHead>
							{table.getHeaderGroups().map((headerGroup) => (
								<TableRow key={headerGroup.id} sx={styles.tableHeaderRow}>
									{headerGroup.headers.map((header) => (
										<TableCell
											key={header.id}
											style={{ ...(header.column.columnDef?.meta?.style ?? {}) }}
											sx={{
												...getCommonPinningStyles(header.column, 'header'),

												...styleFunc(header.column.columnDef?.styles, 'header'),

												...styles.tableHeaderSelectionCell,
											}}
										>
											{header.id === 'Selection' ? (
												header.isPlaceholder ? null : (
													flexRender(header.column.columnDef.header, header.getContext())
												)
											) : (
												<Box sx={styles.tableHeaderSelectionBox}>
													{header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}

													<TanStackColumnSorting header={header} />
												</Box>
											)}
										</TableCell>
									))}
								</TableRow>
							))}

							{table.getHeaderGroups().map((headerGroup) => (
								<TableRow key={headerGroup.id}>
									{headerGroup.headers.map((header) => (
										<TableCell
											key={header.id}
											{...header.column.columnDef.meta}
											sx={{
												...getCommonPinningStyles(header.column, 'header'),
												...styleFunc(header.column.columnDef?.styles, 'header'),

												...styles.tableHeaderCell,
											}}
										>
											{header.column.getCanFilter() ? <TanStackColumnFilter column={header.column} /> : null}
										</TableCell>
									))}
								</TableRow>
							))}
						</TableHead>

						<TableBody
							sx={{
								'& tr:nth-of-type(even)': {
									backgroundColor: '#f6f5f7 !important',
								},
							}}
						>
							{table.getRowModel().rows?.length > 0 ? (
								table.getRowModel().rows.map((row) => (
									<TableRow
										key={row.id}
										sx={styles.tableBodyRow}
										onClick={(e) => {
											e.stopPropagation();

											handleSelectRow(row?.original, selectedTabName);
										}}
									>
										{row.getVisibleCells().map((cell) => {
											return (
												<TableCell
													key={cell.id}
													title={cell.getValue()}
													style={{ ...(cell.column.columnDef?.meta?.style ?? {}) }}
													onClick={() => {
														getDetailsHandler(cell);
													}}
													sx={{
														...getCommonPinningStyles(cell.column, 'body'),
														...(cell.column.columnDef?.dataType?.toLowerCase() === 'currency'
															? { textAlign: 'right', fontVariantNumeric: 'tabular-nums' }
															: {}),
														...(cell.column.columnDef?.dataType?.toLowerCase() === 'integer'
															? { fontVariantNumeric: 'tabular-nums' }
															: {}),
														...styleFunc(cell.column.columnDef?.styles),

														...styles.tableBodyCell,
													}}
												>
													{flexRender(cell.column.columnDef.cell, cell.getContext())}
												</TableCell>
											);
										})}
									</TableRow>
								))
							) : (
								<TableRow>
									<TableCell
										colSpan={columnsWithChat?.length}
										sx={{ borderTop: '1px solid', borderLeft: '1px solid', borderColor: tableDesign.borderColor.primary }}
									>
										<Box component="div" sx={styles.emptyTableBox}>
											<Empty />
										</Box>
									</TableCell>
								</TableRow>
							)}
						</TableBody>
					</Table>
				</TableContainer>

				<Box sx={styles.paginationBox}>
					<TranStackPagination
						table={table}
						sx={styles.pagination}
						// setPagination={setPagination}
					/>
				</Box>
			</MainCard>

			{showModal && (
				<Dialog
					keepMounted
					scroll="paper"
					maxWidth={'lg'}
					fullWidth={true}
					open={showModal}
					onClose={() => setShowModal(false)}
					aria-labelledby="draggable-dialog-title"
				>
					<StructureCaseDetailsModal
						data={caseDetails}
						isLoading={isCaseDetailsLoading}
						isSuccess={isCaseDetailsSuccess}
						onClose={() => setShowModal(false)}
					/>
				</Dialog>
			)}

			<IdentityCaseChatModal
				open={isChatModalOpen}
				onCancel={handleCloseChatModal}
				item={chatModalItem}
				processCode={processDetails?.processCode}
				headerTitle={processDetails?.name}
			/>
		</>
	);
}

export const getCommonPinningStyles = (column, type) => {
	const isPinned = column.getIsPinned();

	// const isLastLeftPinnedColumn = isPinned === "left" && column.getIsLastColumn("left");
	// const isFirstRightPinnedColumn = isPinned === "right" && column.getIsFirstColumn("right");

	const styles = {
		width: column.getSize(),
	};

	if (column.id === 'Selection' && type === 'body') styles['padding'] = 0;
	if (isPinned) styles['zIndex'] = type === 'header' ? 3 : 1;
	if (isPinned) styles['position'] = 'sticky';
	if (isPinned === 'left') styles['left'] = `${column.getStart('left')}px`;
	if (isPinned === 'right') styles['right'] = `${column.getAfter('right')}px`;
	if (type === 'body') styles['background'] = '#ffffff';

	return styles;
};

export function styleFunc(stylesList, component) {
	const styles = {};

	if (stylesList) {
		if (component) {
			stylesList?.forEach(({ key, value }) => {
				const keyPart = key?.split('.');
				if (keyPart[0] === component) {
					styles[keyPart[1]] = value;
				}
			});
		} else {
			stylesList?.forEach(({ key, value }) => {
				styles[key] = value;
			});
		}
	}

	return styles;
}

export function EditAction({
	setEditItem,
	row,
	table,
	processDetails,
	hasEditableColumn,
	approverUserIdFromMeta,
	permissions,
	approveRejectHandler,
	from,
	tableHeader: headMetaData,
	setSelectHistory,
	selectedTabName,
}) {
	const { message: messageApi } = App.useApp();
	const meta = table?.options?.meta;
	const userId = useSelector((state) => state.profile.profileData.userId);
	const hasApprovalPermission = approverUserIdFromMeta ? approverUserIdFromMeta === userId : row?.original?.approverUserId?.includes(userId);

	const recordStatus = row?.original?.recordStatus?.toLowerCase();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();

	const [takenAction, setTakenAction] = useState();
	const [showModal, setShowModal] = useState(false);
	const [modalData, setModalData] = useState({});

	const setSelectedRow = () => {
		meta?.setSelectedRow((old) => ({
			...old,
			[row.id]: !old[row.id],
		}));
	};
	const submitHandler = () => {
		setSelectedRow();
		meta?.saveData(row.index);
	};
	const cancelHandler = () => {
		setSelectedRow();

		meta?.revertData(row.index);
	};
	const editHandler = (e) => {
		e.stopPropagation();
		setTakenAction('edit');

		if (permissions?.edit === false) {
			messageApi.error({
				content: 'You do not have permission to perform this action.',
				icon: <img src={cancelIcon} alt="inactive" width="16px" height="16px" style={{ marginRight: '8px', verticalAlign: 'sub' }} />,
			});
			return;
		}

		if (headMetaData?.meta?.staticFormUrl?.startsWith('/static/') || hasEditableColumn === false) {
			const url = headMetaData?.meta?.staticFormUrl ?? '/case-identity';

			const staticURL = headMetaData?.meta?.staticFormUrl;

			if (staticURL) {
				if (staticURL in staticEditModalList) {
					setEditItem({
						...processDetails,
						staticEditModule: url,
						processCode: processDetails?.processCode,
						processVersion: processDetails?.version,
						processName: processDetails?.name,
						_id: row?.original?.id,
						selectedTabName: selectedTabName,
					});
				} else {
					navigate(`${url}/edit`, {
						state: {
							processCode: processDetails?.processCode,
							processName: processDetails?.name,
							_id: row?.original?.id,
							tab: searchParams.get('tab'),
						},
					});
				}
			} else {
				setEditItem({
					...processDetails,
					processCode: processDetails?.processCode,
					processName: processDetails?.name,
					_id: row?.original?.id,
					selectedTabName: selectedTabName,
				});
			}
		} else {
			setSelectedRow();
		}
	};
	const deleteHandler = () => {
		// meta?.submitOperation(row.original.id, "delete-single", row.index);
		deleteHandler(row.original, processDetails.processCode, permissions);
	};
	const approveHandler = () => {
		// meta?.submitOperation(row.original.id, "approve-single", row.index);
		approveRejectHandler(row.original.id, 'approve-single');
	};
	const rejectHandler = () => {
		// meta?.submitOperation(row.original.id, "reject-single", row.index);
		approveRejectHandler(row.original.id, 'reject-single');
	};
	const viewHandler = (e) => {
		e.stopPropagation();
		let url = from;

		if (headMetaData?.meta?.staticFormUrl?.startsWith('/static/')) {
			url = headMetaData?.meta?.staticFormUrl;
		}

		navigate(`${url}/details`, {
			state: {
				processCode: processDetails?.processCode,
				processName: processDetails?.name,
				_id: row?.original?.id,
				tab: searchParams.get('tab'),
			},
		});
	};

	const onClickHandler = (action) => {
		setModalData({
			head: processDetails?.name,
			action: action,
			label: `Do you want to ${action}?`,
		});
		setShowModal(true);
	};

	const modalSubmitHandler = () => {
		if (modalData?.action === 'delete') {
			deleteHandler();
		} else if (modalData?.action === 'approve') {
			approveHandler();
		} else if (modalData?.action === 'reject') {
			rejectHandler();
		} else if (modalData?.action === 'cancel') {
			cancelHandler();
		} else if (modalData?.action === 'save') {
			submitHandler();
		}
	};

	const permission = {
		edit: permissions.edit /* hasEditableColumn */,
		read: permissions.read,
		delete: permissions.delete,
		approve: hasApprovalPermission,
		reject: hasApprovalPermission,
	};

	return (
		<>
			<Box sx={{ display: 'flex', justifyContent: 'center' }}>
				<Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(37px, 50px))' }}>
					<Tooltip title="History">
						<Box>
							<IconButton
								color="primary"
								onClick={(e) => {
									e.stopPropagation();
									setSelectHistory(row?.original);
								}}
								disabled={row?.original?.history ? false : true}
							>
								<img src={row?.original?.history ? pdfIcon : pdfIconDisable} width={16} height={16} alt="view" />
							</IconButton>
						</Box>
					</Tooltip>

					{permission['read'] && (
						<Tooltip title="View">
							<IconButton color="primary" variant="rounded" onClick={viewHandler}>
								<img src={viewIcon} width={16} height={16} alt="view" />
							</IconButton>
						</Tooltip>
					)}

					{takenAction === 'edit' && meta?.selectedRow?.[row.id] ? (
						<>
							<Tooltip title="Cancel">
								<IconButton color="error" onClick={() => onClickHandler('cancel')}>
									<CloseOutlined />
								</IconButton>
							</Tooltip>

							<Tooltip title="Save">
								<IconButton color="success" onClick={() => onClickHandler('save')}>
									<SendOutlined />
								</IconButton>
							</Tooltip>
						</>
					) : (
						<>
							{recordStatus === 'parked' && hasApprovalPermission ? (
								<>
									{permission['approve'] && (
										<Tooltip title="Approve">
											<IconButton color="success" onClick={() => onClickHandler('approve')}>
												<CheckOutlined />
											</IconButton>
										</Tooltip>
									)}

									{permission['reject'] && (
										<Tooltip title="Reject">
											<IconButton color="error" onClick={() => onClickHandler('reject')}>
												<CloseOutlined />
											</IconButton>
										</Tooltip>
									)}

									{permission['edit'] && (
										<Tooltip title="Edit">
											<IconButton color="primary" onClick={editHandler}>
												<img src={editIcon} width={16} height={16} alt="view" />
											</IconButton>
										</Tooltip>
									)}
								</>
							) : (
								<>
									{recordStatus === 'saved' ||
										(recordStatus === 'draft' && (
											<>
												{permission['edit'] && (
													<Tooltip title="Edit">
														<IconButton color="primary" onClick={editHandler}>
															<img src={editIcon} width={16} height={16} alt="view" />
														</IconButton>
													</Tooltip>
												)}

												{false && (
													<Tooltip title="Delete">
														<IconButton color="error" onClick={() => onClickHandler('delete')}>
															<img src={deleteIcon} width={16} height={16} alt="view" />
														</IconButton>
													</Tooltip>
												)}
											</>
										))}
								</>
							)}
						</>
					)}
				</Box>
			</Box>

			{showModal && (
				<ComptrollerConfirmModal showModal={showModal} setShowModal={setShowModal} modalData={modalData} handleSubmit={modalSubmitHandler} />
			)}
		</>
	);
}

const visibleColumnFunc = (columns) => {
	const visibleColumn = {};

	columns?.forEach((column) => {
		if (column?.columnSerialTable === null) {
			visibleColumn[column?.accessorKey] = false;
		} else {
			visibleColumn[column?.accessorKey] = true;
		}
	});

	return visibleColumn;
};

const piningColumnFunc = (columns) => {
	const pinedColumns = {};
	const firstColumnId = first(columns)?.accessorKey ?? first(columns)?.id;
	const rightPinnedId = (columns || []).find((column) => ['edit', 'Action', 'chat', 'Chat'].includes(column?.id))?.id;

	pinedColumns['left'] = [firstColumnId];
	if (rightPinnedId) pinedColumns['right'] = [rightPinnedId];

	return pinedColumns;
};

function RowEditable({ getValue: initialValue, row, column: { id, columnDef }, table }) {
	const [value, setValue] = useState(initialValue);
	const tableMeta = table.options.meta;
	const rowData = row?.original;

	const onBlur = () => {
		tableMeta.updateSingleCellData(row.index, id, value);
	};

	useEffect(() => {
		setValue(initialValue);
	}, [initialValue]);

	let element;
	let userInfoSchema;
	switch (columnDef.dataType.toLowerCase()) {
		case 'text':
			userInfoSchema = yup.object().shape({
				userInfo: yup.string().typeError('This field must be string'),
			});
			break;
		case 'currency':
			userInfoSchema = yup.object().shape({
				userInfo: yup.number().typeError('This field must be number'),
			});
			break;
		case 'visits':
			userInfoSchema = yup.object().shape({
				userInfo: yup.number().typeError('Visits must be number').required('Required'),
			});
			break;
		default:
			userInfoSchema = yup.object().shape({
				userInfo: yup.string().min(2, 'Too Short!').max(50, 'Too Long!').required('Name is Required'),
			});
			break;
	}

	const isEditable =
		tableMeta?.selectedRow[row.id] &&
		(columnDef?.postType === 'POSTING_DIRECT' || (columnDef?.postType === 'POSTING_PARK' && rowData?.recordStatus === 'saved'));

	if (isEditable) {
		switch (columnDef.dataType.toLowerCase()) {
			case 'currency':
				element = (
					<Box sx={{ '& .MuiOutlinedInput-input': { py: 0.75, px: 1 } }}>
						<NumericFormat
							decimalScale={2}
							fixedDecimalScale
							value={value}
							isAllowed={(inputObj) => {
								const { formattedValue } = inputObj;
								const roundFigureAmount = formattedValue.split('.')[0];
								if (roundFigureAmount.length <= 13) return true;
								return false;
							}}
							thousandSeparator=","
							style={{ textAlign: 'right' }}
							customInput={TextField}
							onValueChange={(values) => {
								const { floatValue } = values;
								setValue(floatValue);
							}}
							onBlur={onBlur}
						/>
					</Box>
				);
				break;
			case 'number':
				element = (
					<Box sx={{ '& .MuiOutlinedInput-input': { py: 0.75, px: 1 } }}>
						<NumericFormat
							decimalScale={2}
							thousandSeparator=","
							value={value}
							isAllowed={(inputObj) => {
								const { formattedValue } = inputObj;
								const roundFigureAmount = formattedValue.split('.')[0];
								if (roundFigureAmount.length <= 13) return true;
								return false;
							}}
							customInput={TextField}
							onValueChange={(values) => {
								const { floatValue } = values;
								setValue(floatValue);
							}}
							onBlur={onBlur}
						/>
					</Box>
				);
				break;
			case 'integer':
				element = (
					<Box sx={{ '& .MuiOutlinedInput-input': { py: 0.75, px: 1 } }}>
						<NumericFormat
							value={value}
							isAllowed={(inputObj) => {
								const { formattedValue } = inputObj;
								const roundFigureAmount = formattedValue.split('.')[0];
								if (roundFigureAmount.length <= 13) return true;
								return false;
							}}
							customInput={TextField}
							onValueChange={(values) => {
								const { floatValue } = values;
								setValue(floatValue);
							}}
							onBlur={onBlur}
						/>
					</Box>
				);
				break;
			default:
				// element = (
				// 	<>
				// 		<Formik
				// 			initialValues={{
				// 				userInfo: initialValue(id),
				// 			}}
				// 			enableReinitialize
				// 			validationSchema={userInfoSchema}
				// 		>
				// 			{({ values, handleChange, errors, touched }) => (
				// 				<Form>
				// 					<TextField
				// 						name="userInfo"
				// 						value={values.userInfo}
				// 						id={`${row.index}-${id}`}
				// 						onChange={(e) => {
				// 							handleChange(e);
				// 							tableMeta.updateSingleCellData(row.index, id, e.target.value);
				// 						}}
				// 						error={touched.userInfo && Boolean(errors.userInfo)}
				// 						helperText={touched.userInfo && errors.userInfo && errors.userInfo}
				// 						sx={{ '& .MuiOutlinedInput-input': { py: 0.75, px: 1 } }}
				// 					/>
				// 				</Form>
				// 			)}
				// 		</Formik>
				// 	</>
				// );
				break;
		}
	} else {
		// Note: This logic is now handled in userTabHook
		// let mainData =
		// 	rowData?.recordStatus === 'parked' && rowData?.parkedData?.[id] && rowData?.parkAction?.toLowerCase() === 'update'
		// 		? rowData?.parkedData?.[id]
		// 		: value;

		let mainData = value;

		switch (columnDef.dataType.toLowerCase()) {
			case 'currency':
				mainData = <Box sx={{ textAlign: 'right' }}>{currencyFormatter(mainData)}</Box>;
				break;
			case 'number':
				mainData = numberFormatter(mainData);
				break;
			case 'calendar':
				// mainData = mainData ? moment(mainData).utc().format('YYYY-MM-DD') : '';
				mainData = mainData ? moment(mainData).format('YYYY-MM-DD') : '';
				break;
			case 'time':
				// mainData = mainData ? moment(value).utc().format('hh:mm A') : '';
				mainData = mainData ? moment(value).format('hh:mm A') : '';
				break;
			default:
				break;
		}

		element = mainData;
	}

	return element;
}

const StructureCaseDetailsModal = ({ data, isLoading, isSuccess, isError, onClose }) => {
	let content = null;
	const theme = useTheme();

	if (isLoading && !isSuccess) {
		content = (
			<Stack sx={{ width: '100%', minHeight: '180px' }} alignItems="center" justifyContent="center">
				<Spin size="large" />
			</Stack>
		);
	}

	const columns = data?.reportDefinition?.reportColumns
		?.filter((item) => item?.columnDataType !== 'Hidden')
		.map((header) => {
			return {
				header: header?.columnLabel,
				accessorKey: header?.columnCode,
				dataType: header?.columnDataType,
			};
		});
	const rows = data?.reportData?.results;

	const table = useReactTable({
		data: rows,
		columns,
		initialState: {
			columnVisibility: visibleColumnFunc(columns),
			columnPinning: piningColumnFunc(columns),
		},
		defaultColumn: {
			cell: RowEditable,
		},
		getCoreRowModel: getCoreRowModel(),
	});

	if (!isLoading && isSuccess) {
		content = (
			<Table aria-label="structure case table" stickyHeader>
				<TableHead>
					{table.getHeaderGroups()?.map((headerGroup) => (
						<TableRow key={headerGroup.id}>
							{headerGroup.headers.map((header) => (
								<TableCell
									key={header.id}
									{...header.column.columnDef.meta}
									sx={{
										...(header.column.columnDef?.dataType?.toLowerCase() === 'currency'
											? { textAlign: 'right', fontVariantNumeric: 'tabular-nums' }
											: {}),
									}}
								>
									{flexRender(header.column.columnDef.header, header.getContext())}
								</TableCell>
							))}
						</TableRow>
					))}
				</TableHead>

				<TableBody
					sx={{
						'& tr:nth-of-type(even)': {
							backgroundColor: `${tableDesign.tableRowBackgroundColor.primary} !important`,
						},
					}}
				>
					{table.getRowModel().rows?.length > 0 ? (
						table.getRowModel().rows?.map((row) => (
							<TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
								{row.getVisibleCells().map((cell) => (
									<TableCell key={cell.id} scope="row" style={{ ...header.column.columnDef.meta.style }}>
										{flexRender(cell.column.columnDef.cell, cell.getContext())}
									</TableCell>
								))}
							</TableRow>
						))
					) : (
						<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
							<TableCell scope="row" sx={{ textAlign: 'center', height: '100px' }} colSpan={columns?.length ?? 0}>
								No Data Found
							</TableCell>
						</TableRow>
					)}
				</TableBody>
			</Table>
		);
	}

	if (!isLoading && isError) {
		content = (
			<Box>
				<Typography variant="body1" color="initial" textAlign="center">
					Server Error
				</Typography>
			</Box>
		);
	}

	return (
		<>
			<Grid
				container
				spacing={2}
				justifyContent="space-between"
				alignItems="center"
				sx={{ bgcolor: '#214689', borderBottom: `1px solid ${theme.palette.divider}` }}
			>
				<Grid item>
					<DialogTitle sx={{ color: 'common.white', display: 'flex', alignItems: 'center' }}>
						{data?.reportDefinition?.name ?? ''}
					</DialogTitle>
				</Grid>
				<Grid item sx={{ mr: 3 }}>
					<CloseOutlined style={{ bdcolor: 'white', color: 'white' }} onClick={onClose} />
				</Grid>
			</Grid>

			<DialogContent sx={{ padding: 0 }}>
				<TableContainer component={Paper} sx={{ maxHeight: 440 }}>
					{content}
				</TableContainer>
			</DialogContent>
		</>
	);
};

// /* eslint-disable */
// import * as yup from 'yup';
// import * as XLSX from 'xlsx';
// import { toastConfig } from 'config';
// import { Form, Formik } from 'formik';
// import { toast } from 'react-toastify';
// import { useSelector } from 'react-redux';
// import moment from 'moment';
// import MainCard from 'components/MainCard';
// import { useCallback, useEffect, useState } from 'react';
// import { useTheme } from '@mui/material/styles';
// import { first, isEmpty, isString } from 'lodash';
// import { Empty, Flex, message, Spin } from 'antd';
// import { NumericFormat } from 'react-number-format';
// import pdfIcon from 'assets/images/icons/pdf_red.svg';
// import LynIcon from 'components/@extended/LynIcon';
// import IconButton from 'components/@extended/IconButton';
// import SendOutlined from '@ant-design/icons/SendOutlined';
// import CloseOutlined from '@ant-design/icons/CloseOutlined';
// import CheckOutlined from '@ant-design/icons/CheckOutlined';
// import cancelIcon from 'assets/images/icons/deactivated.svg';
// import pdfIconDisable from 'assets/images/icons/pdf_gray.svg';
// import viewIcon from 'assets/images/table-icons/view_blue.svg';
// import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
// import editIcon from 'assets/images/table-icons/edit_green.svg';
// import { currencyFormatter, generateExcelFileName, numberFormatter } from 'utils/utils';
// import deleteIcon from 'assets/images/table-icons/delete_red.svg';
// import staticEditModalList from 'static-solutions/staticEditModalList';
// import { TanStackColumnFilter } from 'components/@extended/ColumnFilter';
// import ComptrollerConfirmModal from 'pages/comptroller/ComptrollerConfirmModal';
// import { SelectVisibleColumnV8 } from 'components/@extended/SelectVisibleColumn';
// import { TranStackPagination } from 'components/LynDataTable/DataTablePagination';
// import { TanStackColumnSorting } from 'components/@extended/SortingIconGroup';
// import { useGetSingleIdentityMutation, useGetSpacialCaseDetailsMutation } from 'store/features/process/processApi';
// import { flexRender, getCoreRowModel, getFilteredRowModel, getPaginationRowModel, getSortedRowModel, useReactTable } from '@tanstack/react-table';
// import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, Paper, Stack, TextField, Tooltip, Typography } from '@mui/material';

// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TableRow from '@mui/material/TableRow';

// const enhanceColumnsWithFiltering = (columns) => {
// 	// console.log('columns', columns);
// 	return columns.map((column) => {
// 		// Create a copy to avoid modifying the original objects
// 		const enhancedColumn = { ...column };

// 		// Ensure filtering is properly enabled
// 		enhancedColumn.enableColumnFilter = true;

// 		// For text columns, explicitly define the filter function
// 		if (enhancedColumn.dataType?.toLowerCase() === 'text') {
// 			enhancedColumn.filterFn = 'includesString';
// 		}

// 		return enhancedColumn;
// 	});
// };

// const FILTER_STORAGE_KEY = 'table-column-filters';

// const getInitialColumnFilters = () => {
// 	try {
// 		const saved = localStorage.getItem(FILTER_STORAGE_KEY);
// 		return saved ? JSON.parse(saved) : [];
// 	} catch {
// 		return [];
// 	}
// };

// export function IdentityFeaturedTable({
// 	setData,
// 	data = [],
// 	columns = [],
// 	rowSelection,
// 	processDetails,
// 	setRowSelection,
// 	selectedTabName,
// 	handleSelectRow,
// 	approveRejectHandler,
// 	expectedURLToRedirect,
// 	activeDeactivateHandle,
// 	xlsxFileName = 'lynorg',
// 	setFilterData = () => {},
// }) {
// 	// console.log('data', data);
// 	// console.log('selectedTabName', selectedTabName);

// 	const theme = useTheme();
// 	const location = useLocation();
// 	const [searchParams, setSearchParams] = useSearchParams();

// 	const pageIndexFromParams = searchParams.get('page');
// 	const pageSizeFromParams = searchParams.get('size');

// 	const initialPageIndex = pageIndexFromParams ? Number(pageIndexFromParams) : 0;
// 	const initialPageSize = pageSizeFromParams ? Number(pageSizeFromParams) : 10;

// 	const [originalData, setOriginalData] = useState(() => [...(data || [])]);
// 	const [selectedRow, setSelectedRow] = useState({});
// 	const [showModal, setShowModal] = useState(false);
// 	const [selectedIndex, setSelectedIndex] = useState();

// 	const [columnFilters, setColumnFilters] = useState(getInitialColumnFilters);

// 	const [GetSingleIdentity, { data: singleCaseData, error: singleCaseError, isSuccess: isSingleCaseSuccess, isError: isSingleCaseError }] =
// 		useGetSingleIdentityMutation();

// 	const [GetSpacialCaseDetails, { data: caseDetails, isSuccess: isCaseDetailsSuccess, isLoading: isCaseDetailsLoading }] =
// 		useGetSpacialCaseDetailsMutation();

// 	const handleColumnFiltersChange = (updater) => {
// 		const newFilters = typeof updater === 'function' ? updater(columnFilters) : updater;
// 		setColumnFilters(newFilters);

// 		// Reset page index to 0
// 		table.setPageIndex(0);

// 		// Update URL: set page to 0

// 		// console.log(newFilters, 'new filters');

// 		if (newFilters?.length > 0) {
// 			setSearchParams(
// 				(prev) => {
// 					const newParams = new URLSearchParams(prev);
// 					// newParams.set('page', '0');
// 					newParams.delete('page');

// 					return newParams;
// 				},
// 				{ replace: true }
// 			);
// 		}

// 		// Update URL without navigation (Not Working)
// 		// const newSearchParams = new URLSearchParams(window.location.search);
// 		// newSearchParams.set('page', '0');
// 		// window.history.replaceState(null, '', `${window.location.pathname}?${newSearchParams.toString()}`);
// 	};

// 	const table = useReactTable({
// 		data: data || [],
// 		columns: enhanceColumnsWithFiltering(columns),
// 		state: {
// 			pagination: {
// 				pageIndex: initialPageIndex,
// 				pageSize: initialPageSize,
// 			},
// 			columnFilters,
// 		},
// 		onColumnFiltersChange: handleColumnFiltersChange,
// 		initialState: {
// 			columnVisibility: visibleColumnFunc(columns),
// 			columnPinning: piningColumnFunc(columns),
// 		},
// 		defaultColumn: {
// 			cell: RowEditable,
// 		},
// 		meta: {
// 			selectedRow,
// 			setSelectedRow,
// 			saveData: (rowIndex) => {
// 				const row = data?.[rowIndex];

// 				if (row) {
// 					setSelectedIndex(rowIndex);
// 					GetSingleIdentity({
// 						_id: row.id,
// 						operation: 'update-single',
// 						processCode: processDetails.processCode,
// 						suffixCode: '',
// 						data: row,
// 						version: row?.version,
// 					});
// 				}
// 			},
// 			revertData: (rowIndex) => {
// 				setData((old) => old.map((row, index) => (index === rowIndex ? originalData[rowIndex] : row)));
// 			},
// 			updateSingleCellData: (rowIndex, columnId, value) => {
// 				setData((old) =>
// 					old.map((row, index) => {
// 						if (index === rowIndex) {
// 							return {
// 								...old[rowIndex],
// 								[columnId]: value,
// 							};
// 						}
// 						return row;
// 					})
// 				);
// 			},
// 			submitOperation: (id, operation, rowIndex) => {
// 				setSelectedIndex(rowIndex);
// 				GetSingleIdentity({
// 					_id: id,
// 					operation,
// 					processCode: processDetails.processCode,
// 					suffixCode: '',
// 				});
// 			},
// 		},
// 		filterFns: {
// 			// Standard text filter for better text matching
// 			textFilter: (row, columnId, filterValue) => {
// 				if (!filterValue) return true;
// 				const cellValue = String(row.getValue(columnId) || '').toLowerCase();
// 				const searchValue = String(filterValue).toLowerCase();
// 				return cellValue.includes(searchValue);
// 			},
// 		},
// 		globalFilterFn: 'textFilter',

// 		enableRowSelection: true,
// 		// onRowSelectionChange: setSelectedItems,
// 		getCoreRowModel: getCoreRowModel(),
// 		getSortedRowModel: getSortedRowModel(),
// 		getFilteredRowModel: getFilteredRowModel(),
// 		getPaginationRowModel: getPaginationRowModel(),
// 	});

// 	// console.log('getPageCount & initialPageIndex & initialPageSize', table.getPageCount(), initialPageIndex, initialPageSize);

// 	const getDetailsHandler = (cell) => {
// 		const columnDetailsQuery = cell.column.columnDef?.columnDetailsQuery;
// 		const isEditEnabled = selectedRow?.[cell?.row?.id];

// 		if (!isEditEnabled && columnDetailsQuery) {
// 			const columnKeys = Object.keys(cell.row.original ?? []);
// 			const columnValues = Object.values(cell.row.original ?? []).map((item) => {
// 				if (isString(item)) return item;
// 				return JSON.stringify(item);
// 			});

// 			if (columnValues && columnKeys) {
// 				GetSpacialCaseDetails({
// 					reportCode: columnDetailsQuery,
// 					fieldCodes: columnKeys,
// 					fieldValues: columnValues,
// 				});
// 				setShowModal(true);
// 			}
// 		}
// 	};

// 	const dataExport = useCallback(() => {
// 		const headerArr = table
// 			?.getVisibleLeafColumns()
// 			?.map((item) => item.id)
// 			?.filter((item) => item !== 'Selection' && item !== 'activationStatus' && item !== 'Action');

// 		// Extracting Label of the table
// 		const mainColumn = columns
// 			?.filter((item) => item.id !== 'Selection' && item.key !== 'activationStatus' && item.key !== 'Action')
// 			.reduce((acc, col) => {
// 				acc[col.key] = col.header;
// 				return acc;
// 			}, {});

// 		const Header = headerArr.map((item) => {
// 			if (mainColumn?.[item]) {
// 				return mainColumn?.[item];
// 			} else {
// 				return item;
// 			}
// 		});

// 		const rows = table.getFilteredRowModel().rows;
// 		const rowsArr = rows.map((row) => {
// 			const rowObj = {};
// 			headerArr.forEach((colId) => {
// 				rowObj[colId] = row.getValue(colId);
// 			});
// 			return rowObj;
// 		});

// 		const wb = XLSX.utils.book_new();
// 		const ws = XLSX.utils.json_to_sheet([]);
// 		XLSX.utils.sheet_add_aoa(ws, [Header]);
// 		XLSX.utils.sheet_add_json(ws, rowsArr, { origin: 'A2', skipHeader: true });
// 		XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
// 		XLSX.writeFile(wb, `${generateExcelFileName(xlsxFileName)}.xlsx`);
// 	}, []);

// 	useEffect(() => {
// 		localStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(columnFilters));
// 	}, [columnFilters]);

// 	useEffect(() => {
// 		setRowSelection(table?.getSelectedRowModel()?.flatRows);
// 	}, [table?.getSelectedRowModel()?.flatRows]);

// 	useEffect(() => {
// 		if (isSingleCaseSuccess) {
// 			// set new version form api for new update
// 			if (!isEmpty(singleCaseData?.data)) {
// 				if (singleCaseData?.recordStatus === 'deleted') {
// 					setData((prev) => {
// 						return prev.filter((item) => item.id !== singleCaseData?._id);
// 					});
// 					setOriginalData((prev) => {
// 						return prev.filter((item) => item.id !== singleCaseData?._id);
// 					});
// 				} else {
// 					setData((old) =>
// 						old.map((row, index) => {
// 							if (index === selectedIndex) {
// 								return {
// 									key: index,
// 									recordId: singleCaseData._id,
// 									id: singleCaseData._id,
// 									...singleCaseData?.data,
// 									parkedData: singleCaseData?.parkedData,
// 									recordStatus: singleCaseData.recordStatus,
// 									version: singleCaseData?.version,
// 									parkAction: singleCaseData?.parkAction,
// 								};
// 							}
// 							return row;
// 						})
// 					);

// 					setOriginalData((old) =>
// 						old.map((row, index) => {
// 							if (index === selectedIndex) {
// 								return {
// 									key: index,
// 									recordId: singleCaseData._id,
// 									id: singleCaseData._id,
// 									...singleCaseData?.data,
// 									parkedData: singleCaseData?.parkedData,
// 									recordStatus: singleCaseData.recordStatus,
// 									version: singleCaseData?.version,
// 									parkAction: singleCaseData?.parkAction,
// 								};
// 							}
// 							return row;
// 						})
// 					);
// 				}
// 			}

// 			toast.success('Success! Action completed ', toastConfig);
// 		}

// 		if (isSingleCaseError) {
// 			if (singleCaseError?.data?.code === '501') {
// 				toast.error(singleCaseError?.data?.message, toastConfig);
// 			} else {
// 				toast.error('Failed! Action not completed', toastConfig);
// 			}
// 			setData((old) => old.map((row, index) => (index === selectedIndex ? originalData[selectedIndex] : row)));
// 		}
// 	}, [isSingleCaseSuccess, isSingleCaseError]);

// 	useEffect(() => {
// 		return () => {
// 			// console.log('Component is unmounting. Current URL:', location.pathname);
// 			// Delay to get the next route
// 			setTimeout(() => {
// 				let expectedURLArr = ['/case-identity/details', '/case-identity/edit'];

// 				if (expectedURLToRedirect) {
// 					expectedURLArr.push(`${expectedURLToRedirect}/edit`, `${expectedURLToRedirect}/details`);
// 				}
// 				// console.log('redirect to another location', expectedURLArr.includes(window.location.pathname));
// 				// console.log('window.location.pathname', window.location.pathname);
// 				// console.log('location.pathname', location.pathname);
// 				// console.log('expectedURLArr', expectedURLArr);
// 				// console.log('same', window.location.pathname === location.pathname);
// 				if (window.location.pathname !== location.pathname && !expectedURLArr.includes(window.location.pathname)) {
// 					return window.localStorage.removeItem(FILTER_STORAGE_KEY);
// 				}
// 			}, 0);
// 		};
// 	}, []);

// 	useEffect(() => {
// 		if (table?.getFilteredRowModel()?.flatRows?.length > 0) {
// 			const filterData = table.getFilteredRowModel().flatRows?.map((row) => row.original);

// 			setFilterData(filterData);
// 		}
// 	}, [table?.getFilteredRowModel()?.flatRows]);

// 	return (
// 		<>
// 			<Box content="div" sx={{ display: 'flex', justifyContent: 'space-between' }}>
// 				<SelectVisibleColumnV8 table={table} allColumns={table?.getAllColumns()} visibleColumns={[]} />
// 				<Flex align="center" gap=".5rem">
// 					{Object.keys(rowSelection)?.length > 0 && (
// 						<>
// 							<div>
// 								<b style={{ fontSize: '1rem' }}>{Object.keys(rowSelection)?.length}</b>{' '}
// 								{Object.keys(rowSelection)?.length > 1 ? 'rows' : 'row'} selected
// 							</div>
// 							{![
// 								'Active',
// 								'Worklist',
// 								'Draft',
// 								'All',
// 								// 'Pending Submission',
// 								// 'Under Processing',
// 								// 'Pending Payment',
// 								// 'Pending Disbursement',
// 								// 'Disbursed',
// 								// 'Returned',
// 								// 'Pending Boxing',
// 								// 'Boxed',
// 							]?.includes(selectedTabName) && (
// 								<Tooltip title={Object.keys(rowSelection)?.length > 1 ? 'Activate all' : 'Activate'}>
// 									<Button
// 										className="animated-button"
// 										type="primary"
// 										style={{ backgroundColor: theme.palette.lynTheme.success, color: 'white' }}
// 										onClick={(e) => {
// 											e.stopPropagation();
// 											activeDeactivateHandle('Inactive');
// 										}}
// 									>
// 										{Object.keys(rowSelection)?.length > 1 ? 'Activate all' : 'Activate'}
// 									</Button>
// 								</Tooltip>
// 							)}
// 							{![
// 								'Inactive',
// 								'Worklist',
// 								'Draft',
// 								'All',
// 								// 'Pending Submission',
// 								// 'Under Processing',
// 								// 'Pending Payment',
// 								// 'Pending Disbursement',
// 								// 'Disbursed',
// 								// 'Returned',
// 								// 'Pending Boxing',
// 								// 'Boxed',
// 							]?.includes(selectedTabName) && (
// 								<Tooltip title={Object.keys(rowSelection)?.length > 1 ? 'Deactivate all' : 'Deactivate'}>
// 									<Button
// 										className="animated-button"
// 										type="primary"
// 										// style={{ backgroundColor: theme.palette.lynTheme.submit, color: "white" }}
// 										sx={{ backgroundColor: '#B00020', color: '#fff', '&:hover': { backgroundColor: '#B00020' } }}
// 										onClick={(e) => {
// 											e.stopPropagation();
// 											activeDeactivateHandle('Active');
// 										}}
// 									>
// 										{Object.keys(rowSelection)?.length > 1 ? 'Deactivate all' : 'Deactivate'}
// 									</Button>
// 								</Tooltip>
// 							)}
// 							{['Draft']?.includes(selectedTabName) && (
// 								<Tooltip title={Object.keys(rowSelection)?.length > 1 ? 'Deactivate all' : 'Deactivate'}>
// 									<Button
// 										className="animated-button"
// 										type="primary"
// 										// style={{ backgroundColor: theme.palette.lynTheme.submit, color: "white" }}
// 										sx={{ backgroundColor: '#03396c', color: '#fff', '&:hover': { backgroundColor: '#03396c' } }}
// 										onClick={(e) => {
// 											e.stopPropagation();
// 											activeDeactivateHandle('Save');
// 										}}
// 									>
// 										Submit
// 									</Button>
// 								</Tooltip>
// 							)}
// 							{/* <Tooltip title={Object.keys(rowSelection)?.length > 1 ? "Delete all" : "Delete"}>
// 									<Button
// 										type="primary"
// 										style={{ backgroundColor: theme.palette.lynTheme.delete, color: "white" }}
// 										onClick={(e) => {
// 											e.stopPropagation();
// 											if (typeof deleteHandle === "function") {
// 											let arr = rowSelection?.map((item) => item?.original);
// 											deleteHandle(arr);
// 											}
// 										}}
// 									>
// 										{Object.keys(rowSelection)?.length > 1 ? "Delete all" : "Delete"}
// 									</Button>
// 								</Tooltip> */}
// 							{!['Active', 'NEW_INACTIVE', 'Inactive', 'Draft', 'All']?.includes(selectedTabName) && (
// 								<>
// 									<Tooltip title="Approve">
// 										<Button
// 											type="primary"
// 											className="animated-button"
// 											sx={{
// 												backgroundColor: 'rgb(3, 57, 108)',
// 												color: '#fff',
// 												'&:hover': { backgroundColor: 'rgb(3, 57, 108)' },
// 											}}
// 											// style={{ backgroundColor: theme.palette.lynTheme.delete, color: "white" }}
// 											onClick={(e) => {
// 												e.stopPropagation();
// 												if (typeof approveRejectHandler === 'function') {
// 													const data = table.getSelectedRowModel().flatRows.map((item) => item.original);
// 													approveRejectHandler(data, 'Approve');
// 												}
// 											}}
// 										>
// 											Approve
// 										</Button>
// 									</Tooltip>

// 									<Tooltip title="Reject">
// 										<Button
// 											type="primary"
// 											className="animated-button"
// 											// style={{ margin: "3px", backgroundColor: theme.palette.lynTheme.delete, color: "white" }}
// 											sx={{ backgroundColor: '#B00020', color: '#fff', '&:hover': { backgroundColor: '#B00020' } }}
// 											onClick={(e) => {
// 												e.stopPropagation();
// 												if (typeof approveRejectHandler === 'function') {
// 													const data = table.getSelectedRowModel().flatRows.map((item) => item.original);
// 													approveRejectHandler(data, 'Reject');
// 												}
// 											}}
// 										>
// 											Reject
// 										</Button>
// 									</Tooltip>
// 								</>
// 							)}
// 						</>
// 					)}
// 					<Button
// 						disableRipple
// 						color="secondary"
// 						sx={{
// 							padding: '8px 12px',
// 							color: 'text.primary',
// 							bgcolor: 'common.white',
// 							border: `1px solid ${theme.palette.border}`,
// 						}}
// 						aria-label="open profile"
// 						aria-haspopup="true"
// 						onClick={dataExport}
// 					>
// 						<Stack direction="row" gap={1}>
// 							<LynIcon folder="icons" fileName={'export'} format="svg" sx={{ marginRight: '4px' }} />{' '}
// 							<Typography style={{ mt: '12px' }}>Export</Typography>
// 						</Stack>
// 					</Button>
// 				</Flex>
// 			</Box>

// 			<MainCard content={false} sx={{ overflow: 'hidden', width: '100%', mt: 2, borderColor: '#526375' }}>
// 				<TableContainer
// 					sx={{
// 						width: '100%',
// 						display: 'block',
// 						overflowX: 'auto',
// 						position: 'relative',
// 						maxHeight: `calc(100svh - 330px)`,

// 						'& td, & th': { whiteSpace: 'nowrap' },
// 					}}
// 				>
// 					<Table
// 						stickyHeader
// 						size="medium"
// 						sx={{ tableLayout: 'fixed', '& th:not(:last-of-type)': { borderRight: 1, borderColor: 'common.white' } }}
// 					>
// 						<TableHead>
// 							{table.getHeaderGroups().map((headerGroup) => (
// 								<TableRow key={headerGroup.id} sx={{ height: '48px' }}>
// 									{headerGroup.headers.map((header) => (
// 										<TableCell
// 											key={header.id}
// 											style={{ ...(header.column.columnDef?.meta?.style ?? {}) }}
// 											sx={{
// 												...getCommonPinningStyles(header.column, 'header'),

// 												...styleFunc(header.column.columnDef?.styles, 'header'),
// 												py: 1.5,
// 												backgroundColor: '#526375',
// 												color: '#ffffff',
// 											}}
// 										>
// 											{header.id === 'Selection' ? (
// 												header.isPlaceholder ? null : (
// 													flexRender(header.column.columnDef.header, header.getContext())
// 												)
// 											) : (
// 												<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
// 													{header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}
// 													{/* {header.column.columnDef.meta?.showSortIcon ? <TanStackColumnSorting header={header} /> : null} */}
// 													<TanStackColumnSorting header={header} />
// 												</Box>
// 											)}
// 										</TableCell>
// 									))}
// 								</TableRow>
// 							))}
// 							{table.getHeaderGroups().map((headerGroup) => (
// 								<TableRow key={headerGroup.id}>
// 									{headerGroup.headers.map((header) => (
// 										<TableCell
// 											key={header.id}
// 											{...header.column.columnDef.meta}
// 											sx={{
// 												...getCommonPinningStyles(header.column, 'header'),
// 												// ...(header.column.columnDef?.dataType?.toLowerCase() === 'currency'
// 												// 	? { textAlign: 'right', fontVariantNumeric: 'tabular-nums' }
// 												// 	: {}),
// 												...styleFunc(header.column.columnDef?.styles, 'header'),
// 												p: 0.5,
// 												backgroundColor: '#ebebeb',
// 												position: 'sticky',
// 												top: '49px',
// 												'&:first-of-type': { backgroundColor: '#ebebeb' },
// 												'&:last-child': { borderColor: 'white' },
// 											}}
// 										>
// 											{header.column.getCanFilter() ? <TanStackColumnFilter column={header.column} /> : null}
// 										</TableCell>
// 									))}
// 								</TableRow>
// 							))}
// 						</TableHead>

// 						<TableBody>
// 							{table.getRowModel().rows?.length > 0 ? (
// 								table.getRowModel().rows.map((row) => (
// 									<TableRow
// 										key={row.id}
// 										sx={{ cursor: 'pointer' }}
// 										onClick={(e) => {
// 											e.stopPropagation();

// 											// memorizeClickedItem(row.id, row);
// 											handleSelectRow(row?.original, selectedTabName);
// 										}}
// 									>
// 										{row.getVisibleCells().map((cell) => {
// 											// const renderedValue = cell.renderValue();
// 											return (
// 												<TableCell
// 													key={cell.id}
// 													style={{ ...(cell.column.columnDef?.meta?.style ?? {}) }}
// 													onClick={() => {
// 														getDetailsHandler(cell);
// 													}}
// 													title={cell.getValue()}
// 													sx={{
// 														...getCommonPinningStyles(cell.column, 'body'),
// 														...(cell.column.columnDef?.dataType?.toLowerCase() === 'currency'
// 															? { textAlign: 'right', fontVariantNumeric: 'tabular-nums' }
// 															: {}),
// 														...(cell.column.columnDef?.dataType?.toLowerCase() === 'integer'
// 															? { fontVariantNumeric: 'tabular-nums' }
// 															: {}),
// 														...styleFunc(cell.column.columnDef?.styles),
// 														borderBottom: '1px solid #E0E0E0',
// 														overflow: 'hidden',
// 														textOverflow: 'ellipsis',
// 													}}
// 												>
// 													{flexRender(cell.column.columnDef.cell, cell.getContext())}
// 												</TableCell>
// 											);
// 										})}
// 									</TableRow>
// 								))
// 							) : (
// 								<TableRow>
// 									<TableCell colSpan={columns?.length}>
// 										<Box
// 											component="div"
// 											sx={{
// 												width: '100%',
// 												display: 'flex',
// 												flexDirection: 'column',
// 												justifyContent: 'center',
// 												alignItems: 'center',
// 												height: '350px',
// 											}}
// 										>
// 											<Empty />
// 										</Box>
// 									</TableCell>
// 								</TableRow>
// 							)}
// 						</TableBody>
// 					</Table>
// 				</TableContainer>
// 				<Box sx={{ width: '100%', backgroundColor: '#526375' }}>
// 					<TranStackPagination
// 						sx={{
// 							'& .MuiTablePagination-root': {
// 								color: '#fff',
// 							},
// 						}}
// 						table={table}
// 						// setPagination={setPagination}
// 					/>
// 				</Box>
// 			</MainCard>

// 			{showModal && (
// 				<Dialog
// 					fullWidth={true}
// 					scroll="paper"
// 					maxWidth={'lg'}
// 					open={showModal}
// 					keepMounted
// 					onClose={() => setShowModal(false)}
// 					aria-labelledby="draggable-dialog-title"
// 				>
// 					<StructureCaseDetailsModal
// 						data={caseDetails}
// 						isLoading={isCaseDetailsLoading}
// 						isSuccess={isCaseDetailsSuccess}
// 						onClose={() => setShowModal(false)}
// 					/>
// 				</Dialog>
// 			)}
// 		</>
// 	);
// }

// export const getCommonPinningStyles = (column, type) => {
// 	const isPinned = column.getIsPinned();

// 	// const isLastLeftPinnedColumn = isPinned === "left" && column.getIsLastColumn("left");
// 	// const isFirstRightPinnedColumn = isPinned === "right" && column.getIsFirstColumn("right");

// 	const styles = {
// 		width: column.getSize(),
// 	};

// 	if (column.id === 'Selection' && type === 'body') styles['padding'] = 0;
// 	if (isPinned) styles['zIndex'] = type === 'header' ? 3 : 1;
// 	if (isPinned) styles['position'] = 'sticky';
// 	// if (isLastLeftPinnedColumn) styles["boxShadow"] = "-3px 0 4px -4px gray inset";
// 	// if (isFirstRightPinnedColumn) styles["boxShadow"] = "3px 0 4px -4px gray inset";
// 	if (isPinned === 'left') styles['left'] = `${column.getStart('left')}px`;
// 	if (isPinned === 'right') styles['right'] = `${column.getAfter('right')}px`;
// 	if (type === 'body') styles['background'] = '#ffffff';

// 	return styles;
// };

// export function styleFunc(stylesList, component) {
// 	const styles = {};

// 	if (stylesList) {
// 		if (component) {
// 			stylesList?.forEach(({ key, value }) => {
// 				const keyPart = key?.split('.');
// 				if (keyPart[0] === component) {
// 					styles[keyPart[1]] = value;
// 				}
// 			});
// 		} else {
// 			stylesList?.forEach(({ key, value }) => {
// 				styles[key] = value;
// 			});
// 		}
// 	}

// 	return styles;
// }

// export function EditAction({
// 	setEditItem,
// 	row,
// 	table,
// 	processDetails,
// 	hasEditableColumn,
// 	approverUserIdFromMeta,
// 	permissions,
// 	approveRejectHandler,
// 	from,
// 	tableHeader: headMetaData,
// 	setSelectHistory,
// }) {
// 	const meta = table?.options?.meta;
// 	const userId = useSelector((state) => state.profile.profileData.userId);
// 	const hasApprovalPermission = approverUserIdFromMeta ? approverUserIdFromMeta === userId : row?.original?.approverUserId?.includes(userId);

// 	const recordStatus = row?.original?.recordStatus?.toLowerCase();
// 	const navigate = useNavigate();
// 	const [searchParams] = useSearchParams();

// 	const [takenAction, setTakenAction] = useState();
// 	const [showModal, setShowModal] = useState(false);
// 	const [modalData, setModalData] = useState({});

// 	const setSelectedRow = () => {
// 		meta?.setSelectedRow((old) => ({
// 			...old,
// 			[row.id]: !old[row.id],
// 		}));
// 	};
// 	const submitHandler = () => {
// 		setSelectedRow();
// 		meta?.saveData(row.index);
// 	};
// 	const cancelHandler = () => {
// 		setSelectedRow();

// 		meta?.revertData(row.index);
// 	};
// 	const editHandler = (e) => {
// 		e.stopPropagation();
// 		setTakenAction('edit');

// 		if (permissions?.edit === false) {
// 			message.error({
// 				content: 'You do not have permission to perform this action.',
// 				icon: <img src={cancelIcon} alt="inactive" width="16px" height="16px" style={{ marginRight: '8px', verticalAlign: 'sub' }} />,
// 			});
// 			return;
// 		}

// 		if (headMetaData?.meta?.staticFormUrl?.startsWith('/static/') || hasEditableColumn === false) {
// 			const url = headMetaData?.meta?.staticFormUrl ?? '/case-identity';

// 			const staticURL = headMetaData?.meta?.staticFormUrl;

// 			if (staticURL) {
// 				if (staticURL in staticEditModalList) {
// 					setEditItem({
// 						...processDetails,
// 						staticEditModule: url,
// 						processCode: processDetails?.processCode,
// 						processVersion: processDetails?.version,
// 						processName: processDetails?.name,
// 						_id: row?.original?.id,
// 					});
// 				} else {
// 					navigate(`${url}/edit`, {
// 						state: {
// 							processCode: processDetails?.processCode,
// 							processName: processDetails?.name,
// 							_id: row?.original?.id,
// 							tab: searchParams.get('tab'),
// 						},
// 					});
// 				}
// 			} else {
// 				setEditItem({
// 					...processDetails,
// 					processCode: processDetails?.processCode,
// 					processName: processDetails?.name,
// 					_id: row?.original?.id,
// 				});
// 			}
// 		} else {
// 			setSelectedRow();
// 		}
// 	};
// 	const deleteHandler = () => {
// 		// meta?.submitOperation(row.original.id, "delete-single", row.index);
// 		deleteHandler(row.original, processDetails.processCode, permissions);
// 	};
// 	const approveHandler = () => {
// 		// meta?.submitOperation(row.original.id, "approve-single", row.index);
// 		approveRejectHandler(row.original.id, 'approve-single');
// 	};
// 	const rejectHandler = () => {
// 		// meta?.submitOperation(row.original.id, "reject-single", row.index);
// 		approveRejectHandler(row.original.id, 'reject-single');
// 	};
// 	const viewHandler = (e) => {
// 		e.stopPropagation();
// 		let url = from;

// 		if (headMetaData?.meta?.staticFormUrl?.startsWith('/static/')) {
// 			url = headMetaData?.meta?.staticFormUrl;
// 		}

// 		navigate(`${url}/details`, {
// 			state: {
// 				processCode: processDetails?.processCode,
// 				processName: processDetails?.name,
// 				_id: row?.original?.id,
// 				tab: searchParams.get('tab'),
// 			},
// 		});
// 	};

// 	const onClickHandler = (action) => {
// 		setModalData({
// 			head: processDetails?.name,
// 			action: action,
// 			label: `Do you want to ${action}?`,
// 		});
// 		setShowModal(true);
// 	};

// 	const modalSubmitHandler = () => {
// 		if (modalData?.action === 'delete') {
// 			deleteHandler();
// 		} else if (modalData?.action === 'approve') {
// 			approveHandler();
// 		} else if (modalData?.action === 'reject') {
// 			rejectHandler();
// 		} else if (modalData?.action === 'cancel') {
// 			cancelHandler();
// 		} else if (modalData?.action === 'save') {
// 			submitHandler();
// 		}
// 	};

// 	const permission = {
// 		edit: permissions.edit /* hasEditableColumn */,
// 		read: permissions.read,
// 		delete: permissions.delete,
// 		approve: hasApprovalPermission,
// 		reject: hasApprovalPermission,
// 	};

// 	return (
// 		<>
// 			<Box sx={{ display: 'flex', justifyContent: 'center' }}>
// 				<Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(37px, 50px))' }}>
// 					<Tooltip title="History">
// 						<Box>
// 							<IconButton
// 								color="primary"
// 								onClick={(e) => {
// 									e.stopPropagation();
// 									setSelectHistory(row?.original);
// 								}}
// 								disabled={row?.original?.history ? false : true}
// 							>
// 								<img src={row?.original?.history ? pdfIcon : pdfIconDisable} width={16} height={16} alt="view" />
// 							</IconButton>
// 						</Box>
// 					</Tooltip>

// 					{permission['read'] && (
// 						<Tooltip title="View">
// 							<IconButton color="primary" variant="rounded" onClick={viewHandler}>
// 								<img src={viewIcon} width={16} height={16} alt="view" />
// 							</IconButton>
// 						</Tooltip>
// 					)}

// 					{takenAction === 'edit' && meta?.selectedRow?.[row.id] ? (
// 						<>
// 							<Tooltip title="Cancel">
// 								<IconButton color="error" onClick={() => onClickHandler('cancel')}>
// 									<CloseOutlined />
// 								</IconButton>
// 							</Tooltip>

// 							<Tooltip title="Save">
// 								<IconButton color="success" onClick={() => onClickHandler('save')}>
// 									<SendOutlined />
// 								</IconButton>
// 							</Tooltip>
// 						</>
// 					) : (
// 						<>
// 							{recordStatus === 'parked' && hasApprovalPermission ? (
// 								<>
// 									{permission['approve'] && (
// 										<Tooltip title="Approve">
// 											<IconButton color="success" onClick={() => onClickHandler('approve')}>
// 												<CheckOutlined />
// 											</IconButton>
// 										</Tooltip>
// 									)}

// 									{permission['reject'] && (
// 										<Tooltip title="Reject">
// 											<IconButton color="error" onClick={() => onClickHandler('reject')}>
// 												<CloseOutlined />
// 											</IconButton>
// 										</Tooltip>
// 									)}

// 									{/* for testing */}
// 									{permission['edit'] && (
// 										<Tooltip title="Edit">
// 											<IconButton color="primary" onClick={editHandler}>
// 												<img src={editIcon} width={16} height={16} alt="view" />
// 											</IconButton>
// 										</Tooltip>
// 									)}
// 								</>
// 							) : (
// 								<>
// 									{recordStatus === 'saved' ||
// 										(recordStatus === 'draft' && (
// 											<>
// 												{permission['edit'] && (
// 													<Tooltip title="Edit">
// 														<IconButton color="primary" onClick={editHandler}>
// 															<img src={editIcon} width={16} height={16} alt="view" />
// 														</IconButton>
// 													</Tooltip>
// 												)}

// 												{/* Note's: identity item cannot be deleted. temporarily disabled in case of future demand. */}
// 												{false && (
// 													<Tooltip title="Delete">
// 														<IconButton color="error" onClick={() => onClickHandler('delete')}>
// 															<img src={deleteIcon} width={16} height={16} alt="view" />
// 														</IconButton>
// 													</Tooltip>
// 												)}
// 											</>
// 										))}
// 								</>
// 							)}
// 						</>
// 					)}
// 				</Box>
// 			</Box>
// 			{showModal && (
// 				<ComptrollerConfirmModal showModal={showModal} setShowModal={setShowModal} modalData={modalData} handleSubmit={modalSubmitHandler} />
// 			)}
// 		</>
// 	);
// }

// const visibleColumnFunc = (columns) => {
// 	const visibleColumn = {};
// 	columns?.forEach((column) => {
// 		if (column?.columnSerialTable === null) {
// 			visibleColumn[column?.accessorKey] = false;
// 		} else {
// 			visibleColumn[column?.accessorKey] = true;
// 		}
// 	});

// 	return visibleColumn;
// };

// const piningColumnFunc = (columns) => {
// 	const pinedColumns = {};
// 	const firstColumnId = first(columns)?.accessorKey ?? first(columns)?.id;

// 	pinedColumns['left'] = [firstColumnId];
// 	pinedColumns['right'] = ['edit'];

// 	return pinedColumns;
// };

// function RowEditable({ getValue: initialValue, row, column: { id, columnDef }, table }) {
// 	const [value, setValue] = useState(initialValue);
// 	const tableMeta = table.options.meta;
// 	const rowData = row?.original;

// 	// console.log('mainData', value);

// 	const onBlur = () => {
// 		tableMeta.updateSingleCellData(row.index, id, value);
// 	};

// 	useEffect(() => {
// 		setValue(initialValue);
// 	}, [initialValue]);

// 	let element;
// 	let userInfoSchema;
// 	switch (columnDef.dataType.toLowerCase()) {
// 		case 'text':
// 			userInfoSchema = yup.object().shape({
// 				userInfo: yup.string().typeError('This field must be string'),
// 			});
// 			break;
// 		case 'currency':
// 			userInfoSchema = yup.object().shape({
// 				userInfo: yup.number().typeError('This field must be number'),
// 			});
// 			break;
// 		case 'visits':
// 			userInfoSchema = yup.object().shape({
// 				userInfo: yup.number().typeError('Visits must be number').required('Required'),
// 			});
// 			break;
// 		default:
// 			userInfoSchema = yup.object().shape({
// 				userInfo: yup.string().min(2, 'Too Short!').max(50, 'Too Long!').required('Name is Required'),
// 			});
// 			break;
// 	}

// 	const isEditable =
// 		tableMeta?.selectedRow[row.id] &&
// 		(columnDef?.postType === 'POSTING_DIRECT' || (columnDef?.postType === 'POSTING_PARK' && rowData?.recordStatus === 'saved'));

// 	if (isEditable) {
// 		switch (columnDef.dataType.toLowerCase()) {
// 			case 'currency':
// 				element = (
// 					<Box sx={{ '& .MuiOutlinedInput-input': { py: 0.75, px: 1 } }}>
// 						<NumericFormat
// 							decimalScale={2}
// 							fixedDecimalScale
// 							value={value}
// 							isAllowed={(inputObj) => {
// 								const { formattedValue } = inputObj;
// 								const roundFigureAmount = formattedValue.split('.')[0];
// 								if (roundFigureAmount.length <= 13) return true;
// 								return false;
// 							}}
// 							thousandSeparator=","
// 							style={{ textAlign: 'right' }}
// 							customInput={TextField}
// 							onValueChange={(values) => {
// 								const { floatValue } = values;
// 								setValue(floatValue);
// 							}}
// 							onBlur={onBlur}
// 						/>
// 					</Box>
// 				);
// 				break;
// 			case 'number':
// 				element = (
// 					<Box sx={{ '& .MuiOutlinedInput-input': { py: 0.75, px: 1 } }}>
// 						<NumericFormat
// 							decimalScale={2}
// 							thousandSeparator=","
// 							value={value}
// 							isAllowed={(inputObj) => {
// 								const { formattedValue } = inputObj;
// 								const roundFigureAmount = formattedValue.split('.')[0];
// 								if (roundFigureAmount.length <= 13) return true;
// 								return false;
// 							}}
// 							customInput={TextField}
// 							onValueChange={(values) => {
// 								const { floatValue } = values;
// 								setValue(floatValue);
// 							}}
// 							onBlur={onBlur}
// 						/>
// 					</Box>
// 				);
// 				break;
// 			case 'integer':
// 				element = (
// 					<Box sx={{ '& .MuiOutlinedInput-input': { py: 0.75, px: 1 } }}>
// 						<NumericFormat
// 							value={value}
// 							isAllowed={(inputObj) => {
// 								const { formattedValue } = inputObj;
// 								const roundFigureAmount = formattedValue.split('.')[0];
// 								if (roundFigureAmount.length <= 13) return true;
// 								return false;
// 							}}
// 							customInput={TextField}
// 							onValueChange={(values) => {
// 								const { floatValue } = values;
// 								setValue(floatValue);
// 							}}
// 							onBlur={onBlur}
// 						/>
// 					</Box>
// 				);
// 				break;
// 			default:
// 				element = (
// 					<>
// 						<Formik
// 							initialValues={{
// 								userInfo: initialValue(id),
// 							}}
// 							enableReinitialize
// 							validationSchema={userInfoSchema}
// 						>
// 							{({ values, handleChange, errors, touched }) => (
// 								<Form>
// 									<TextField
// 										name="userInfo"
// 										value={values.userInfo}
// 										id={`${row.index}-${id}`}
// 										onChange={(e) => {
// 											handleChange(e);
// 											tableMeta.updateSingleCellData(row.index, id, e.target.value);
// 										}}
// 										error={touched.userInfo && Boolean(errors.userInfo)}
// 										helperText={touched.userInfo && errors.userInfo && errors.userInfo}
// 										sx={{ '& .MuiOutlinedInput-input': { py: 0.75, px: 1 } }}
// 									/>
// 								</Form>
// 							)}
// 						</Formik>
// 					</>
// 				);
// 				break;
// 		}
// 	} /* else if (rowData?.recordStatus === 'parked' && rowData?.parkedData?.[id] && rowData?.parkAction?.toLowerCase() === 'update') {
// 		// let mainData = value;
// 		let parkData = rowData?.parkedData?.[id];

// 		switch (columnDef.dataType.toLowerCase()) {
// 			case 'currency':
// 				// mainData = currencyFormatter(mainData);
// 				parkData = currencyFormatter(parkData);
// 				break;
// 			case 'number':
// 				// mainData = numberFormatter(mainData);
// 				parkData = numberFormatter(parkData);
// 				break;
// 			default:
// 				break;
// 		}

// 		element = (
// 			<>
// 				// <Box sx={{ textDecoration: "line-through" }}>{mainData}</Box>
// 				<Box>{parkData}</Box>
// 			</>
// 		);
// 	} */ else {
// 		let mainData =
// 			rowData?.recordStatus === 'parked' && rowData?.parkedData?.[id] && rowData?.parkAction?.toLowerCase() === 'update'
// 				? rowData?.parkedData?.[id]
// 				: value;

// 		switch (columnDef.dataType.toLowerCase()) {
// 			case 'currency':
// 				mainData = <Box sx={{ textAlign: 'right' }}>{currencyFormatter(mainData)}</Box>;
// 				break;
// 			case 'number':
// 				mainData = numberFormatter(mainData);
// 				break;
// 			case 'calendar':
// 				mainData = mainData ? moment(mainData).utc().format('YYYY-MM-DD') : '';
// 				break;
// 			case 'time':
// 				mainData = mainData ? moment(value).utc().format('hh:mm A') : '';
// 				break;
// 			default:
// 				break;
// 		}

// 		element = mainData;
// 	}

// 	return element;
// }

// const StructureCaseDetailsModal = ({ data, isLoading, isSuccess, isError, onClose }) => {
// 	let content = null;
// 	const theme = useTheme();

// 	if (isLoading && !isSuccess) {
// 		content = (
// 			<Stack sx={{ width: '100%', minHeight: '180px' }} alignItems="center" justifyContent="center">
// 				<Spin size="large" />
// 			</Stack>
// 		);
// 	}

// 	const columns = data?.reportDefinition?.reportColumns
// 		?.filter((item) => item?.columnDataType !== 'Hidden')
// 		.map((header) => {
// 			return {
// 				header: header?.columnLabel,
// 				accessorKey: header?.columnCode,
// 				dataType: header?.columnDataType,
// 			};
// 		});
// 	const rows = data?.reportData?.results;

// 	const table = useReactTable({
// 		data: rows,
// 		columns,
// 		initialState: {
// 			columnVisibility: visibleColumnFunc(columns),
// 			columnPinning: piningColumnFunc(columns),
// 		},
// 		defaultColumn: {
// 			cell: RowEditable,
// 		},
// 		getCoreRowModel: getCoreRowModel(),
// 	});

// 	if (!isLoading && isSuccess) {
// 		content = (
// 			<Table aria-label="structure case table" stickyHeader>
// 				<TableHead>
// 					{table.getHeaderGroups()?.map((headerGroup) => (
// 						<TableRow key={headerGroup.id}>
// 							{headerGroup.headers.map((header) => (
// 								<TableCell
// 									key={header.id}
// 									{...header.column.columnDef.meta}
// 									sx={{
// 										...(header.column.columnDef?.dataType?.toLowerCase() === 'currency'
// 											? { textAlign: 'right', fontVariantNumeric: 'tabular-nums' }
// 											: {}),
// 									}}
// 								>
// 									{flexRender(header.column.columnDef.header, header.getContext())}
// 								</TableCell>
// 							))}
// 						</TableRow>
// 					))}
// 				</TableHead>
// 				<TableBody>
// 					{table.getRowModel().rows?.length > 0 ? (
// 						table.getRowModel().rows?.map((row) => (
// 							<TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
// 								{row.getVisibleCells().map((cell) => (
// 									<TableCell key={cell.id} scope="row" style={{ ...header.column.columnDef.meta.style }}>
// 										{flexRender(cell.column.columnDef.cell, cell.getContext())}
// 									</TableCell>
// 								))}
// 							</TableRow>
// 						))
// 					) : (
// 						<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
// 							<TableCell scope="row" sx={{ textAlign: 'center', height: '100px' }} colSpan={columns?.length ?? 0}>
// 								No Data Found
// 							</TableCell>
// 						</TableRow>
// 					)}
// 				</TableBody>
// 			</Table>
// 		);
// 	}

// 	if (!isLoading && isError) {
// 		content = (
// 			<Box>
// 				<Typography variant="body1" color="initial" textAlign="center">
// 					Server Error
// 				</Typography>
// 			</Box>
// 		);
// 	}

// 	return (
// 		<>
// 			{/* <DialogTitle sx={{ bgcolor: "#214689", color: "common.white" }}>{data?.reportDefinition?.name ?? ""}</DialogTitle> */}
// 			<Grid
// 				container
// 				spacing={2}
// 				justifyContent="space-between"
// 				alignItems="center"
// 				sx={{ bgcolor: '#214689', borderBottom: `1px solid ${theme.palette.divider}` }}
// 			>
// 				<Grid item>
// 					<DialogTitle sx={{ color: 'common.white', display: 'flex', alignItems: 'center' }}>
// 						{data?.reportDefinition?.name ?? ''}
// 					</DialogTitle>
// 				</Grid>
// 				<Grid item sx={{ mr: 3 }}>
// 					<CloseOutlined style={{ bdcolor: 'white', color: 'white' }} onClick={onClose} />
// 				</Grid>
// 			</Grid>
// 			<DialogContent sx={{ padding: 0 }}>
// 				<TableContainer component={Paper} sx={{ maxHeight: 440 }}>
// 					{content}
// 				</TableContainer>
// 			</DialogContent>
// 			{/* <DialogActions sx={{ px: 3, pb: 3, display: "flex", justifyContent: "center" }}>
//             <Button variant="contained" sx={{ bgcolor: "#00914f", color: "common.white", width: "6rem", borderRadius: "6px", "&:hover": { bgcolor: "#00914f" } }} onClick={handleOk}>
//               Yes
//             </Button>
//             <Button variant="contained" sx={{ bgcolor: "#B00020", color: "common.white", width: "6rem", borderRadius: "6px", "&:hover": { bgcolor: "#B00020" } }} onClick={handleClose}>
//               No
//             </Button>
//           </DialogActions> */}
// 		</>
// 	);
// };
